module.exports = __webpack_public_path__ + "img/placeholder.d75d28f4.jpg";